module.exports = __webpack_public_path__ + "static/media/15UN-Habitat3.7f501350.jpg";